var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRevenueCardDesktopBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1302,
    height: 546,
    viewBox: "0 0 1302 546",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M570.147 83.4635C562.662 87.8615 554.402 90.7873 545.813 92.0832C530.173 94.3691 513.72 91.7581 498.81 96.9795C479.161 103.884 466.468 122.764 457.63 141.58C448.791 160.395 442.112 180.776 428.303 196.323C399.675 228.584 346.435 229.821 309.543 207.385C284.993 192.446 266.857 169.455 253.921 143.523C247.492 130.494 242.243 116.916 238.236 102.953C229.15 71.6953 224.807 38.5589 209.083 10.0506C207.169 6.58249 205.048 3.23277 202.73 0.0196734L570.147 83.4635Z",
    fill: "#E6C6ED",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1301.51 338.671V545.406H1002.31C1003.31 536.661 1005.2 528.04 1007.95 519.674C1017.57 491.024 1037.16 466.729 1063.19 451.163C1076.74 443.009 1091.89 437.84 1107.62 436.004C1128.17 433.719 1151.34 436.476 1167.18 423.26C1176.71 415.306 1181.34 403.164 1187.28 392.291C1204.19 361.386 1236.05 337.671 1271.37 335.182C1281.55 334.512 1291.76 335.694 1301.51 338.671V338.671Z",
    fill: "#AE9FB3"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    d: "M1212.72 545.406H817C818.235 534.199 820.952 523.206 825.078 512.716C834.623 488.302 853.711 465.029 879.64 461.308C890.813 459.676 901.79 461.879 912.417 465.829C919.847 468.575 927.942 468.951 935.593 466.906C943.245 464.861 950.077 460.494 955.155 454.405C962.539 445.55 971.995 438.662 982.68 434.356C992.609 430.502 1003.28 428.952 1013.89 429.821C1024.51 430.69 1034.79 433.956 1043.96 439.374C1049.34 442.714 1054.4 446.537 1059.09 450.798C1072.69 462.81 1084.91 476.861 1102.04 482.084C1119.85 487.502 1139.31 482.084 1157.56 485.715C1184.31 491.076 1203.98 515.532 1211.74 541.734C1212.08 542.968 1212.41 544.192 1212.72 545.406Z",
    fill: "url(#paint0_linear_4068_37494)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M490.538 0C495.472 0 499.243 4.42917 498.158 9.24291C493.148 31.466 483.403 52.3758 469.553 70.5119C438.295 110.88 386.577 134.347 335.807 131.003C330.413 130.658 324.978 129.99 319.523 129.301C291.007 125.46 261.946 118.459 236.365 130.425C214.645 140.558 200.76 162.393 181.158 176.224C155.516 194.321 121.001 197.279 91.1741 187.623C61.3474 177.967 36.0885 156.739 17.6258 131.327C11.6746 123.127 6.36326 114.468 1.13609 105.754C0.391885 104.514 0 103.094 0 101.647V8C0 3.58172 3.58172 0 8 0H490.538Z",
    fill: "url(#paint1_linear_4068_37494)",
    style: {
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M201.942 325.682C205.907 308.173 194.906 290.769 177.37 286.81C159.834 282.852 142.405 293.837 138.44 311.346C134.476 328.856 145.477 346.259 163.013 350.218C180.548 354.177 197.978 343.192 201.942 325.682Z",
    fill: "#CBB3D2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M328.67 295.688C331.795 292.927 332.086 288.159 329.321 285.04C326.556 281.92 321.781 281.629 318.657 284.39C315.533 287.151 315.242 291.919 318.007 295.038C320.772 298.158 325.546 298.449 328.67 295.688Z",
    fill: "#CBB3D2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M216.554 336.772C216.554 337.772 216.156 338.731 215.448 339.438C214.74 340.146 213.779 340.543 212.777 340.543C211.775 340.543 210.815 340.146 210.106 339.438C209.398 338.731 209 337.772 209 336.772C209 335.771 209.398 334.812 210.106 334.105C210.815 333.397 211.775 333 212.777 333C213.779 333 214.74 333.397 215.448 334.105C216.156 334.812 216.554 335.771 216.554 336.772Z",
    fill: "#D0AFD9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M363.347 260.772C363.347 261.772 362.949 262.731 362.241 263.438C361.533 264.146 360.572 264.543 359.57 264.543C359.074 264.543 358.583 264.446 358.125 264.256C357.666 264.066 357.25 263.789 356.899 263.438C356.549 263.088 356.27 262.672 356.08 262.215C355.891 261.757 355.793 261.267 355.793 260.772C355.793 260.276 355.891 259.786 356.08 259.328C356.27 258.871 356.549 258.455 356.899 258.105C357.25 257.754 357.666 257.477 358.125 257.287C358.583 257.098 359.074 257 359.57 257C360.572 257 361.533 257.397 362.241 258.105C362.949 258.812 363.347 259.771 363.347 260.772Z",
    fill: "#CBB3D2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4068_37494",
    x1: 817,
    y1: 487.51,
    x2: 1212.72,
    y2: 487.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4068_37494",
    x1: 0,
    y1: 96.522,
    x2: 499.955,
    y2: 96.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenueCardDesktopBg);
export default __webpack_public_path__ + "static/media/RevenueCardDesktopBg.778b7b917e114ae031efcb849f90d092.svg";
export { ForwardRef as ReactComponent };